import Header from '@/components/site/Header';
import Hero from '@/components/site/Hero';
import Stats from '@/components/site/Stats';
import About from '@/components/site/About';
import Reasons from '@/components/site/Reasons';
import Services from '@/components/site/Services';
import Impact from '@/components/site/Impact';
import StaffProcess from '@/components/site/StaffProcess';
import Safety from '@/components/site/Safety';
import Records from '@/components/site/Records';
import ClientProcess from '@/components/site/ClientProcess';
import ActionVideo from '@/components/site/ActionVideo';
import Sectors from '@/components/site/Sectors';
import QuoteForm from '@/components/site/QuoteForm';
import FinalCta from '@/components/site/FinalCta';
import Footer from '@/components/site/Footer';

const Home = () => {
  return (
    <div className="overflow-hidden">
      <Header />
      <main>
        <Hero />
        <Stats />
        <About />
        <Reasons />
        <Services />
        <Impact />
        <StaffProcess />
        <Safety />
        <Records />
        <ClientProcess />
        <ActionVideo />
        <Sectors />
        <QuoteForm />
        <FinalCta />
      </main>
      <Footer />
    </div>
  );
};

export default Home;